export default "__VITE_ASSET__BiHRRWO9__"